import React from 'react'
import { cn } from 'lib/utils'
import NotesRailFilters from './NotesRailFilters'
import NotesRailContributors from './NotesRailContributors'
import NotesRailGallery from './NotesRailGallery'
import type { NoteFacets, NoteFilterId, NoteImageEntry } from './notesWorkspace.types'

interface NotesRailProps {
	facets: NoteFacets
	/** Images for the currently visible notes, so the gallery tracks the feed. */
	visibleImages: NoteImageEntry[]
	filter: NoteFilterId
	onFilterChange: (filter: NoteFilterId) => void
	activeAuthorId?: string | null
	onAuthorChange: (authorId: string | null) => void
	onImageSelect: (entry: NoteImageEntry) => void
	supportsReplies: boolean
	className?: string
}

/**
 * The right rail.
 *
 * Rendered in the grid's second column at xl and above, and inside a Sheet
 * below it, so the same component serves both without duplicating the sections.
 */
const NotesRail: React.FC<NotesRailProps> = ({
	facets,
	visibleImages,
	filter,
	onFilterChange,
	activeAuthorId,
	onAuthorChange,
	onImageSelect,
	supportsReplies,
	className,
}) => (
	<div className={cn('space-y-4', className)} data-testid="notes-rail">
		<NotesRailFilters
			facets={facets}
			filter={filter}
			onFilterChange={onFilterChange}
			supportsReplies={supportsReplies}
		/>
		<NotesRailContributors
			contributors={facets.contributors}
			activeAuthorId={activeAuthorId}
			onSelect={onAuthorChange}
		/>
		<NotesRailGallery images={visibleImages} onSelect={onImageSelect} />
	</div>
)

export default NotesRail
